"use client";

import { Check, Copy } from "lucide-react";
import { CopyButton } from "@/components/ui/copy-button";
import { buttonVariants } from "@/components/ui/button";

export function DocPageCopy({ title, label }: { title: string; label: string }) {
  return <CopyButton label={label} className={buttonVariants({ variant: "outline", size: "sm" })}
    value={() => `${title}\n\n${document.querySelector<HTMLElement>("[data-reading-body] .wmde-markdown")?.innerText ?? ""}`}>
    {(copied) => <>{copied ? <Check className="size-3.5" /> : <Copy className="size-3.5" />}<span>{label}</span></>}
  </CopyButton>;
}
